import React from 'react';
import PropTypes from 'prop-types';
import { forgotPasswordShape } from 'utils/shapes';
import {
  Text,
  Link,
  Box,
  Heading,
  Panel,
  PanelContent,
  PanelWrapper,
} from 'components';

const ForgotPasswordSentView = ({ createAccountEnabled, forgotPassword, register, loginEnabled, isKeplerPlatform }) => (
  <PanelWrapper>
    <Panel textAlign="center">
      <Heading mb="small">
        <span>{forgotPassword.title}</span>
      </Heading>

      <Box mb="medium">
        <Heading
          id="forgotPassword.emailSent"
          fontSize="medium"
        />
      </Box>

      <PanelContent centered>
        {loginEnabled && (
          <Box mb="fine">
            <Link
              to={{ name: 'log-in' }}
              id="logIn"
              fontSize="small"
            />
          </Box>
        )}

        {createAccountEnabled && register && !isKeplerPlatform && (
          <Text
            id="noAccountCreateAccount"
            values={{
              createAccountLink: (
                <Link
                  key="createAccountLink"
                  textDecoration="underline"
                  to={{ name: 'create-account' }}
                  id="createAccount"
                />
              ),
            }}
            color="secondary"
            fontSize="small"
          />
        )}
      </PanelContent>
    </Panel>
  </PanelWrapper>
);

ForgotPasswordSentView.propTypes = {
  createAccountEnabled: PropTypes.bool.isRequired,
  forgotPassword: forgotPasswordShape.isRequired,
  register: PropTypes.bool,
  loginEnabled: PropTypes.bool,
  isKeplerPlatform: PropTypes.bool,
};

ForgotPasswordSentView.defaultProps = {
  register: true,
  loginEnabled: true,
  isKeplerPlatform: false,
};

export default ForgotPasswordSentView;
